export const visibleClass = 'PianoOverlay--Visible';
export const hiddenClass = 'PianoOverlay--Hidden';
export const openText = 'Open';
export const closedText = 'Closed';

// End Banner elements
export const endBannerElement = document.querySelector( '[data-js-piano-end-banner]' );

export const endBannerSelectors = {
	image: '[data-js-piano-end-banner-image]',
	wrapper: '[data-js-piano-end-banner-wrapper]',
	link: '[data-js-piano-end-banner-link]',
	leftColumn: '[data-js-piano-end-banner-left-column]',
	rightColumn: '[data-js-piano-end-banner-right-column]',
};

// Exit Overlay elements
export const centralOverlayElement = document.querySelector( '[data-js-piano-central-overlay]' );
